import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Posodobitve",
  "description": "",
  "published": "2007-01-08T00:00:00.000Z",
  "redirect_from": ["/blog/posodobitve/swizec/328"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Sem hotel dodati zanimive nove funkcionalnosti na stran in posodobiti osnovne skripte in sem nekako uspel uniciti konfiguracijo stranskih menijev in staticnih strani z enim samim preprostim zamahom. Instalacija novih modulov tudi ne poteka tako gladko, kot sem upal, saj je bil odkrit hrosc v samem instalacijskem programu, ki ga bo treba v cim krajsem casu odpraviti.`}</p>
    <p>{`Glavna srz tega posta je, da se mi v tem trenutku vec ne ljubi s tem ukvarjati in bom posodabljanje dokoncal jutri.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      